export { CarbonFootprintPage } from './CarbonFootprint'
